import { useTracking } from '@xing-com/crate-communication-tracking';

export type TrackParams = {
  page?: string;
  PropTrackAction?: string;
  hashedUserId?: string;
  signupChannel?: string;
  EventRegistrationUnconfirmed?: number;
  EventRegistrationFirstLogin?: number;
  EventLogout?: number;
  intention?: string;
};

export type NwtTrackParams = {
  page: string;
  event: string;
  context?: string;
  intention?: string;
  scrambled_id?: string;
};

type LoginTrackingType = {
  trackPageView: (params: TrackParams) => void;
  trackNwtInteraction: (params: NwtTrackParams) => void;
};

const useLoginTracking = (): LoginTrackingType => {
  const { track: trackNwt } = useTracking();

  const trackPageView = ({ page, signupChannel }: TrackParams): void => {
    trackNwt({
      type: 'nwt',
      event: 'viewed_screen',
      eventSchema: 'basic',
      sentBy: 'welcome',
      page: `welcome/${page}`,
      entryPoint: signupChannel ? `signup_channel_${signupChannel}` : undefined,
    });
  };

  const trackNwtInteraction = ({
    page,
    event,
    context,
    intention,
    scrambled_id,
  }: NwtTrackParams): void => {
    trackNwt({
      type: 'nwt',
      event,
      context,
      eventSchema: 'basic',
      sentBy: 'welcome',
      page: `welcome/${page}`,
      ...(intention && { intention: intention }),
      ...(scrambled_id && { userId: scrambled_id }),
    });
  };

  return {
    trackPageView,
    trackNwtInteraction,
  };
};

export { useLoginTracking };
